 import Skeleton from '@/components/Skeleton'
import PhotoIcon from '@/components/icons/PhotoIcon'
import React from 'react'
 
 export default function () {
  return (
    <Skeleton className=" w-[200px] h-[200px] flex items-center justify-center rounded-lg"  >
    <div className="flex items-center justify-center w-[200px] h-[200px] bg-gray-300 rounded">
      <PhotoIcon />
    </div>
  </Skeleton>
   )
 }
 